<template>
  <MoleculeFrameCard main-theme="success" spacing="sm" data-cy="contract-signed-activate-account">
    <div class="flex items-center gap-1 mb-3">
      <AtomPicto
        name="application"
        :alt="t('subscription.contractSigned.activateAccount.title')"
        size="md"
      />
      <div class="flex min-w-0 flex-1 flex-col">
        <AtomText
          :text="t('subscription.contractSigned.activateAccount.title')"
          font-style="font-semibold"
        />
        <p>
          <AtomText
            is-tag="span"
            font-size="text-sm"
            :text="t('subscription.contractSigned.activateAccount.descriptionBefore')"
          /><AtomText
            is-tag="span"
            font-size="text-sm"
            font-style="font-semibold"
            :text="email"
            data-cy="contract-signed-activate-account-email"
          /><AtomText
            is-tag="span"
            font-size="text-sm"
            :text="t('subscription.contractSigned.activateAccount.descriptionAfter')"
          />
        </p>
      </div>
    </div>
    <MoleculeButton
      variant="primary"
      size="md"
      expanded
      :label="t('subscription.contractSigned.activateAccount.button')"
      data-cy="contract-signed-activate-account-button"
      @click="goToCustomerArea"
    />
  </MoleculeFrameCard>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type Props = {
  email: string;
};

defineProps<Props>();

const goToCustomerArea = () => {
  const customerAreaUrl = import.meta.env.VITE_CUSTOMER_AREA_URL;
  window.open(customerAreaUrl, '_blank');
  return;
};

const { t } = useI18n();
</script>

<style scoped></style>
